import $ from 'jquery'

window.addEventListener('DOMContentLoaded', () => {
  // Detect IE browser.

  if (navigator.userAgentData) {
    let uaList = navigator.userAgentData.brands;
    let auBrands = [];
    for (const element of uaList) {
      auBrands.push(element.brand);
    }

    let brandsString = auBrands.join();
    if (/Microsoft Edge/i.test(brandsString)) {
      $('body').addClass('ie edge');
    }

  } else {
    let ua = window.navigator.userAgent;
    let msie = ua.indexOf("MSIE ");

    if (msie > 0) {
      $('body').addClass('ie ie' + parseInt(ua.substring(msie + 5, ua.indexOf(".", msie))));
    }
    else if (!!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      $('body').addClass('ie ie11');
    }
    else if (/Edg\/\d./i.test(navigator.userAgent)) {
      $('body').addClass('ie edge');
    }
  }



  let scrollPos = 0
  const nav = document.querySelector('.site-header')
  const wrapper = document.querySelector('.wrapper')
  const $backToTop = $('.back-to-top')

  if (navigator.userAgentData) {
    if (navigator.userAgentData.platform.indexOf('Win') !== -1) {
      $('body').addClass('windows-os')
    }
  } else {
    if (navigator.appVersion.indexOf('Win') !== -1) {
      $('body').addClass('windows-os')
    }
  }

  setTimeout(() => {
    if (nav == null) return
    // TODO: refactor. This code is not stable and should be refactored.
    // Sometimes "site-header__innerPages" classname produce regressions for mobile header (IOS)
    if (!nav.closest('body').classList.contains('search-widget') && !nav.classList.contains('search-results') && !nav.closest('body').classList.contains('path-booking') ) {
      nav.classList.add('site-header__innerPages');
    }
  }, 0);

  function checkPosition() {
    if (nav) {
      let windowY = Math.max(
        window.pageYOffset,
        document.documentElement.scrollTop,
        document.body.scrollTop,
      )
      if (windowY === 0) {
        nav.classList.remove('fixed', 'sticky-wrapper', 'sticky-wrapper-top')
      } else if (windowY < scrollPos) {
        // Scrolling UP
        nav.classList.remove('sticky-wrapper')
        nav.classList.add('fixed', 'sticky-wrapper-top')
        wrapper.classList.remove('sticky-navigation')
      } else {
        // Scrolling DOWN
        nav.classList.remove('sticky-wrapper-top')
        nav.classList.add('fixed', 'sticky-wrapper')
        wrapper.classList.add('sticky-navigation')
      }

      // Toggle back to top button
      if (window.pageYOffset > window.innerHeight * 3 && window.innerWidth <= 768) {
        $backToTop.fadeIn()
      } else {
        $backToTop.fadeOut()
      }

      scrollPos = windowY
    }
  }

  $backToTop.on('click', () => {
    $('html, body').animate({ scrollTop: 0 }, 400)
  })

  window.addEventListener('scroll', checkPosition)
})
